import type { QuizStep } from '../../types';
import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';

interface Props {
  step: QuizStep;
  value: string | undefined;
  onChange: (value: string) => void;
}

export function SingleChoiceStep({ step, value, onChange }: Props) {
  return (
    <div className="flex w-full flex-col gap-2">
      {step.options?.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={cn(
            'flex w-full items-center justify-between rounded-xl bg-white py-3 pl-4 pr-2 text-left shadow-[0_0_8px_rgba(26,22,19,0.03)] transition-colors',
            value === option.value && 'ring-2 ring-mf-green/40',
          )}
        >
          <span className="font-body text-[15px] font-bold leading-5 text-mf-neutral-900">
            {option.label}
          </span>
          <ChevronRight className="size-6 shrink-0 text-mf-neutral-400" strokeWidth={1.75} />
        </button>
      ))}
    </div>
  );
}
